import { Typography as MuiTypography, styled } from '@mui/material';

export const StyledTypography = styled(MuiTypography)(({ theme }) => ({
  color: theme.palette.custom.OV.sys.outline,
  fontSize: '0.85rem',
  marginLeft: '0.5',
}));
